import { AlertController, ToastController, LoadingController } from "ionic-angular";
import { Injectable } from '@angular/core';

@Injectable()
export class MessageHelper {

    private loadingComponent: any = null;

    constructor(private alertCtrl: AlertController, private toastCtrl: ToastController,
        private loadingCtrl: LoadingController) {
    }

    /**
     * Cria loading
     * @param spinner string
     * @param content string
     */
    createLoading(spinner: string = "crescent", content: string = "Carregando...") {
        this.loadingComponent = this.loadingCtrl.create({
            spinner: spinner,
            content: content
        });
    }

    /**
     * Mostra o loading criado
     */
    showLoading()
    {
        if (this.loadingComponent != null && this.loadingComponent != undefined)
        {
            this.loadingComponent.present();
        }
    }

    /**
     * Fecha caso exista o loading
     */
    closeLoading()
    {
        if (this.loadingComponent != null && this.loadingComponent != undefined)
        {
            this.loadingComponent.dismiss();
        }
    }

    /**
     * Mostra alert na tela
     * @param title string
     * @param message string
     */
    showAlert(title: string, message: string) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        alert.present();
    }

    /**
     * Mostra um toast na tela
     * @param message string
     * @param position string
     * @param duration number
     */
    showToast(message: string, position: string = 'bottom', duration: number = 3000) {
        let toast = this.toastCtrl.create({
            message: message,
            duration: duration,
            position: position
        });
        toast.present();
    }

}


// WEBPACK FOOTER //
// ./src/providers/helpers/messages.ts